/** "Modifiable in Voyage" booking custom field, in the internal section. */
export const MODIFIABLE_IN_VOYAGE_CUSTOM_FIELD_ID = 'fcd65a04-68dd-4728-998c-f713f137a1d4'
